import Vue from "vue";

Vue.directive("open-mobile-search",
    {
        bind(el, binding)
        {
            el.onclick = function(event)
            {
                event.preventDefault();
                document.querySelector(".header-search").classList.toggle("header-search--open");
                if (document.querySelector(".header-search").classList.contains("header-search--open"))
                {
                    document.querySelector(".header-search__input").focus();
                }
            };
        }
    });
